import { Button, Drawer, Flex, Form, Input, Row, Spin, Tooltip } from 'antd'

import { Icon } from '@iconify/react/dist/iconify.js'
import ResultForm from './ResultForm'

const AddResultDrawer = (props) => {
    const {
        stateTestRun = {},
        setStateTestRun = () => {},
        handleTestCaseList = () => {},
        selectedRowKeys = [],
        setSelectedRowKeys = () => {},
        reportId = '',
        allFilterRecord = false,
        filteredRecordCount = 0,
    } = props

    const isOpen = stateTestRun?.drawerEdit || false

    const handleClose = () => {
        const finalState = {
            ...stateTestRun,
            drawerEdit: false,
        }
        setStateTestRun(finalState)
    }

    // const isEdit = stateTestCase?.action === 'edit'
    return (
        <Drawer
            placement="right"
            width={700}
            style={{
                height: '100vh',
            }}
            styles={{
                body: {
                    padding: '0px',
                    scrollbarColor: 'auto',
                    overflowX: 'hidden',
                },
                wrapper: {
                    scrollbarColor: 'auto',
                },
                content: {
                    scrollbarColor: 'auto',
                },
            }}
            rootClassName="testReportDrawer"
            closeIcon={null}
            open={isOpen}
            title={
                <Row
                    justify="space-between"
                    style={{
                        columnGap: '15px',
                    }}
                    align="center"
                >
                    <span style={{ fontSize: '16px', fontWeight: '700' }}>
                        Add Result
                    </span>
                    <Tooltip title="Close" placement="top">
                        <Icon
                            icon="ph:arrow-line-right"
                            onClick={() => {
                                handleClose()
                            }}
                            height={20}
                            width={20}
                            style={{
                                cursor: 'pointer',
                            }}
                        />
                    </Tooltip>
                </Row>
            }
        >
            <ResultForm
                stateTestRun={stateTestRun}
                setStateTestRun={setStateTestRun}
                handleTestCaseList={handleTestCaseList}
                selectedRowKeys={selectedRowKeys}
                setSelectedRowKeys={setSelectedRowKeys}
                reportId={reportId}
                allFilterRecord={allFilterRecord}
                filteredRecordCount={filteredRecordCount}
            />
        </Drawer>
    )
}

export default AddResultDrawer
